import chat from './ai_workforce/chat'

export default {
  chat,
}
